import styled from 'styled-components';
import { Loader as LoaderLayoutComponent } from '@playbookux/playbook-web-core';

export const Loader = styled(LoaderLayoutComponent).attrs(() => ({
  inline: false,
}))``;
